<template>
  <div>
    <shop-auto-notifications
      :shopID="shopID"
      @siteAlert="(e) => $emit('siteAlert', e)"
      @siteAlertSuccess="(e) => $emit('siteAlertSuccess', e)"
      @siteAlertInfo="(e) => $emit('siteAlertInfo', e)"
    ></shop-auto-notifications>
  </div>
</template>

<script>
import ShopAutoNotifications from './pieces/ShopAutoNotifications.vue';

export default {
  name: 'AutoNotifications',
  components: {
    ShopAutoNotifications,
  },
  computed: {
    shopID: function () {
      if (this.$store.state.userShops.length > 0)
        return this.$store.state.userShops[0].idBarberShop;
      return 0;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/backend/AutoNotifications.vue